module.exports = __webpack_public_path__ + "media/images/area/feature/kyushu/related/th_3-62cf1b1ecfedd30b5942e3ab88d28b2c.jpg";